import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';

const firebaseConfig = {
    apiKey: "AIzaSyC14feV6sPCbzeMLOCiVr8EJepb9Y4GlcQ",
    authDomain: "dddd-5ae95.firebaseapp.com",
    projectId: "dddd-5ae95",
    storageBucket: "dddd-5ae95.appspot.com",
    messagingSenderId: "754150119246",
    appId: "1:754150119246:web:59950884da938f7dd2301f",
    measurementId: "G-H6FZD618PF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);


export { db, app }
